import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router";
import { selectCurrentUser } from "../../store/slices/auth/authSlice";
import { useValidateQuery } from "../API/SessionAPI";

const RequireAuth = ({ allowedRoles }) => {
  const location = useLocation();
  const user = useSelector(selectCurrentUser);

  const {
    data: session,
    isLoading,
    isError: invalidRoles,
  } = useValidateQuery(
    { roles: allowedRoles },
    {
      pollingInterval: 15000,
      refetchOnMountOrArgChange: true,
      skip: !user,
    }
  );

  if (isLoading) return <div>Loading...</div>;
  if (invalidRoles) return <Navigate to="/login" state={{ from: location }} />;

  return user && session?.isValid ? (
    <Outlet />
  ) : user ? (
    /* Logged in but no permission */
    <Navigate
      to="/application"
      state={{ from: location, errorMsg: "Unauthorized, Missing Permissions!" }}
      replace
    />
  ) : (
    /* Not logged in */
    <Navigate to="/login" state={{ from: location }} replace />
  );
};
export default RequireAuth;
